import { WebPlugin } from '@capacitor/core';
export class PhoneCallWeb extends WebPlugin {
    async call(options) {
        const { phone } = options;
        window.open(`tel:${phone}`);
    }
}
//# sourceMappingURL=web.js.map